<div class="with-floating-button">
    <div class="content">
        <page-header [title]="'admin.comptabilite.modeRemb.title.liste' | translate" [listeItems]="listeTabItems" [selectedIndex]="selectedIndex"></page-header>

        <list-view *ngIf="listeModeRemboursement" [liste]="listeModeRemboursement"></list-view>
    </div>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>
